export enum EPreferences {
  PRINTING_MATERIAL_SEPARATION = "PRINTING_MATERIAL_SEPARATION",
  ROUND_PRICING = "ROUND_PRICING",
  System_VAT = "System_VAT",
  DEFUALT_AUTO_DISCOUNT = "DEFUALT_AUTO_DISCOUNT",
  DOCUMENT_AGENT = "DOCUMENT_AGENT",
  PRODUCTION_TICKET_SIZE = "PRODUCTION_TICKET_SIZE",
  SHOW_PHONE_PREFIX = "SHOW_PHONE_PREFIX",
  SET_QUOTE_CREATOR_AS_QUOTE_AGENT = "SET_QUOTE_CREATOR_AS_QUOTE_AGENT",
  ADDITIONAL_DELIVERY_TIME = "ADDITIONAL_DELIVERY_TIME",
  SHOW_DISCOUNT_ITEMS = "SHOW_DISCOUNT_ITEMS",
  DELIVERY_TICKET_SIZE = "DELIVERY_TICKET_SIZE",
  SHOW_DELIVERY_ITEMS = "SHOW_DELIVERY_ITEMS",
  IGNORE_IN_CALCULATED_WORKFLOWS = "IGNORE_IN_CALCULATED_WORKFLOWS",
  SHOW_GRAPHICS_ITEMS = "SHOW_GRAPHICS_ITEMS",
  IS_BUSINESS_NUMBER_REQUIRED_IN_CUSTOMERS = "IS_BUSINESS_NUMBER_REQUIRED_IN_CUSTOMERS",
  BOARDMISSION_PDF_FORMAT = "BOARDMISSION_PDF_FORMAT",
  SHOW_AGENT_IN_PRODUCTION_FLOOR = "SHOW_AGENT_IN_PRODUCTION_FLOOR",
  PRODUCTION_FLOOR_TABLE_FONT_SIZE = "PRODUCTION_FLOOR_TABLE_FONT_SIZE",
  SHOW_PRODUCT_NAME_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_PRODUCT_NAME_COLUMN_IN_PRODUCTION_FLOOR",
  SHOW_DESCRIPTION_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_DESCRIPTION_COLUMN_IN_PRODUCTION_FLOOR",
  SHOW_NOTES_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_NOTES_COLUMN_IN_PRODUCTION_FLOOR",
  RUSH_FEE = "RUSH_FEE",
  HIDE_VAT_FROM_DOCUMENTS = "HIDE_VAT_FROM_DOCUMENTS",
  ADDRESSES_WITH_COUNTRY_AND_STATE = "ADDRESSES_WITH_COUNTRY_AND_STATE",
  ADDRESSES_REQUIRED_FOR_ORDER = "ADDRESSES_REQUIRED_FOR_ORDER",
  HIDE_ITEM_CODE_FROM_DOCUMENT_CART = "HIDE_ITEM_CODE_FROM_DOCUMENT_CART",
  USE_PRINTNODE_AFTER_PREPRESS = "USE_PRINTNODE_AFTER_PREPRESS",
  INITIALIZE_ORDER_FOLDERS_AFTER_CREATION = "INITIALIZE_ORDER_FOLDERS_AFTER_CREATION",
  DEFAULT_PAYMENT_TERMS = "DEFAULT_PAYMENT_TERMS",
  DEFAULT_NUMBER_OF_ROWS_IN_TABLES = "DEFAULT_NUMBER_OF_ROWS_IN_TABLES",
  AGENT_REQUIRED_IN_DOC = "AGENT_REQUIRED_IN_DOC",
  IS_AGENT_REQUIRED_IN_CUSTOMERS = "IS_AGENT_REQUIRED_IN_CUSTOMERS",
  IS_PAYMENT_TERMS_REQUIRED_IN_CUSTOMERS = "IS_PAYMENT_TERMS_REQUIRED_IN_CUSTOMERS",
  DELIVERY_DATE_REQUIRED_IN_DOC = "DELIVERY_DATE_REQUIRED_IN_DOC",
  USE_PRINTNODE_AFTER_UPLOAD_FILE = "USE_PRINTNODE_AFTER_UPLOAD_FILE",
  SET_CURRENT_USER_AS_CLIENT_AGENT = "SET_CURRENT_USER_AS_CLIENT_AGENT",
  ASK_TO_PRINT_WITH_PRICES_IN_DELIVERY_NOTES = "ASK_TO_PRINT_WITH_PRICES_IN_DELIVERY_NOTES",
  ASK_TO_GROUP_SIMILAR_JOBS = "ASK_TO_GROUP_SIMILAR_JOBS",
  DELIVERY_DATE_REQUIRED_IN_QUOTE = "DELIVERY_DATE_REQUIRED_IN_QUOTE",
  AGENT_REQUIRED_IN_QUOTE = "AGENT_REQUIRED_IN_QUOTE",
}
